import { Bars3Icon } from '@heroicons/react/24/outline';
import type { Milestone } from '../../services/api/milestones';
import { formatDateRange } from './milestoneCounts';

export interface MilestoneRowDragOverlayProps {
  milestone: Milestone;
}

/**
 * Quick 260914-ims — milestone-row DragOverlay ghost. Static div, no
 * listeners, no droppable — mirrors TaskCardDragOverlay.tsx's idiom exactly.
 * Compact row-header lookalike so the ghost reads as the row it came from
 * (same tokens as KanbanSwimlane.tsx's row header at :727-744 / :788-795).
 */
export function MilestoneRowDragOverlay({ milestone }: MilestoneRowDragOverlayProps) {
  const dateRange = formatDateRange(milestone.startDate, milestone.endDate);

  return (
    <div
      data-testid="milestone-row-drag-overlay"
      className="w-72 rounded-lg border border-ms-border-strong bg-ms-surface-2 px-3 py-2 shadow-xl opacity-90 rotate-[1.5deg] cursor-grabbing"
    >
      <div className="flex items-center gap-2">
        <Bars3Icon className="h-4 w-4 shrink-0 text-ms-text-muted" />
        <div className="flex flex-col min-w-0">
          <span className="text-sm font-medium text-ms-text truncate">{milestone.name}</span>
          {dateRange && (
            <span className="text-xs font-medium text-ms-text-secondary truncate">
              {dateRange}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
